(() => {
  function enhance(scope) {
    scope.querySelectorAll('[data-variant-chips]').forEach(group => {
      const form = group.closest('form');
      const select = form.querySelector('[data-variant-select]');
      if (!select) return;
      group.hidden = false;
      form.querySelector('[data-variant-dropdown]').hidden = true;
      sync(form, select.value);
    });
  }
  function sync(form, value) {
    form.querySelectorAll('[data-variant-chip]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.variantChip === value));
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-variant-chip]');
    if (!button || button.disabled) return;
    const select = button.closest('form').querySelector('[data-variant-select]');
    select.value = button.dataset.variantChip;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) sync(event.target.closest('form'), event.target.value);
  });
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  enhance(document);
})();
